import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'

import DeleteTrip from '../Trips/DeleteTrip'
import EditTripName from '../Trips/EditTripName'

import LinePenIcon from 'LuxKit/Icons/line/LinePenIcon'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import type { BasicTrip, FullTrip } from 'tripPlanner/types/common'
import { getTripPermissions } from 'tripPlanner/utils'

interface Props {
  trip: BasicTrip | FullTrip
}

export default function TripPanelActionMenu(props: Props) {
  const intl = useIntl()
  const { trip } = props
  const [mode, setMode] = useState<'view' | 'edit' | 'delete'>('view')
  const onDeleteTripClicked = useCallback(() => setMode('delete'), [])
  const onEditNameClicked = useCallback(() => setMode('edit'), [])
  const { canEdit, canAdmin } = getTripPermissions(trip)

  return (
    <ModalBase dismissible={mode !== 'delete'}>
      {mode === 'view' && (
        <>
          <ModalHeader title={trip.name} />
          <ModalBody>
            <ModalContent>
              {canEdit && (
                <ClickableListItem
                  startIcon={<LinePenIcon size="S" />}
                  title={intl.formatMessage({
                    id: 'N2N5Ej-mRuYmZq5Dxabi',
                    defaultMessage: 'Edit name',
                    description: 'Action menu item to edit the trip name in the trip planner feature',
                  })}
                  onClick={onEditNameClicked}
                />
              )}
              {canAdmin && (
                <ClickableListItem
                  startIcon={<LineTrashAltIcon size="S" />}
                  onClick={onDeleteTripClicked}
                  title={intl.formatMessage({
                    id: 'Sn0SHhM2IaLGD-fuQzZY',
                    defaultMessage: 'Delete trip',
                    description: 'Action menu item to delete the trip in the trip planner feature',
                  })}
                />
              )}
            </ModalContent>
          </ModalBody>
        </>
      )}
      {mode === 'edit' && <EditTripName trip={trip} />}
      {mode === 'delete' && <DeleteTrip trip={trip} />}
    </ModalBase>
  )
}
